<template>
  <div>
<!--    <div v-if="loading">加载中...</div>-->
<!--    <div v-else-if="projectData">-->
<!--      <h1>{{ projectData.name }}</h1>-->
<!--      <p>{{ projectData.description }}</p>-->
<!--    </div>-->
<!--    <div v-else>项目不存在</div>-->
  </div>
</template>

<script>


import {ProjectPage, selectProjectByPage} from "@/request/api";

export default {
  name: 'tempIndex',
  props: ['projectId'], // 通过 props 接收
  data() {
    return {
      projectData: null,
      loading: false
    }
  },
  created() {
    console.log('项目ID:', this.projectId);
  },
  mounted() {},
  watch: {
    // 监听路由参数变化（动态路由场景）
    '$route.params.projectId': {
      handler(newId) {
        if (this.isMobile()) {
          window.location.href = 'https://fym.article.life-oasis.com/pages/project/detail?projectId=' + newId;
          return;
        }
        this.fetchProjectData(newId);
      },
      immediate: true // 首次加载时触发
    }
  },
  methods: {

    // 监听当前设备是pc端 还是移动端
    isMobile() {
      let ua = navigator.userAgent.toLowerCase();
      if (/iphone|ipad|ipod|android/.test(ua)) {
        return true;
      } else {
        return false;
      }
    },

    async fetchProjectData(projectId) {
      try {
        this.loading = true;
        //本地记录 然后跳转到首页
        localStorage.setItem('projectId',projectId);

        ProjectPage().then(res => {
          if (res.code == 200) {
            this.projectData = res.data
            localStorage.setItem('projectName',res.data.projectName);
            this.$router.push({
              path:'/'
            })
          }else {
            localStorage.removeItem("projectId")
            this.$router.push({
              name:'NotFound'
            })
          }
        }).catch(err => {
          localStorage.removeItem("projectId")
          console.log(err)
          this.$router.push({
            name:'NotFound'
          })
        })




        // const response = await axios.get(`/api/projects/${projectId}`);
        // this.projectData = response.data;
      } catch (error) {
        localStorage.removeItem("projectId")
        console.error('数据加载失败:', error);
        this.$router.push({
          name:'NotFound'
        })
      } finally {
        this.loading = false;
      }
    }

  }

}
</script>

<style lang="scss" scoped>
</style>